import { Link } from "@StarberryUtils"
import React, { useRef, useState, useEffect } from "react"
import SEO from "../../Components/seo";
import { Container, Row, Col } from "react-bootstrap"
import ReactMarkdown from "react-markdown"
import { Helmet } from "react-helmet"
import gql from "graphql-tag"
import { useStaticQuery, graphql } from "gatsby";
import { useQuery } from "@apollo/client"
import PropertyDetailsBanner from "./PropertyDetailsBanner/PropertyDetailsBanner"
import StaticContactBlock from "@Components/Static/StaticContactBlock/StaticContactBlock"
import { useLocation } from "@reach/router"
import PropertyMap from "./PropertyMap/PropertyMap"
import GoogleMap from "../map/googleMap"
import PropertyAbout from "./PropertyAbout/PropertyAbout"
import SimilarPropery from "./SimilarPropery/SimilarPropery"
import FloorPlanModal from "../PropertyDetails/FloorPlanModal/floorPlanModal"
import ScrollAnimation from "react-animate-on-scroll"
import Modal from "react-bootstrap/Modal"
import { uknumberformatFront1 } from "@Components/common/common-functions"
import $ from "jquery"
import SendFriendForm from "@Components/forms/sendfrnd-form"
import { isSold } from '@Components/common/site/utils';
import ContactBlock from "../ContactBlock/ContactBlock"
// My account
import { UserObjectStoreProvider, SaveItem, useUserObjectState, useAuthState, isBrowser, storeData, isAuthenticated } from "@starberry/myaccount-website-utils";

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share"
import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share"
import { VALUATION_PAGE_UEL } from "@Components/common/site/constants"
import "./PropertyDetails.scss"
import { isMobileOnly } from "react-device-detect"
import FloorPlanModalDetails from "../../Components/PropertyDetails/FloorPlanModalDetails/floorPlanModalDetails"
import VirtualTourModalDetails from "../../Components/PropertyDetails/VirtualTourModalDetails/virtualTourModalDetails"
import BreadcrumbsDetail from "../BreadCrumbsDetail/BreadCrumbsDetail"
import BrandLogoInner from "../../images/logo-inner.svg"
import { get } from "lodash";
import { isNotAvailble, isSoldOnly } from "../common/site/utils";

const GET_ALL_TEAMS = gql`
  query GetTeam {
    teams(where: { Publish: true }, sort: "createdAt:asc") {
      id
      Repeat_Id
      Name
      Email
      Image {
        url
      }
    }
  }
`

const SavePropertyWrap = (props) => {

  const { state, services } = useUserObjectState()
  const { services: authServices } = useAuthState()
  const isAuthenticated = authServices.isAuthenticated()

  useEffect(() => {
    if (isAuthenticated) {
      // on page load get the users saved objects
      services.getUserobject({ type: "property", state: true })
    }
  }, [])

  return (
    <>
      <SaveItem type="property" pid={props.property_id}>
        <Link className="wishlist-icn" to="#"><i className="icon-heart"></i></Link>
      </SaveItem>
    </>
  )
}


const PropertyDetails = props => {

  const officeData = useStaticQuery(graphql`
      query{
        glstrapi {
            offices(publicationState: LIVE) {  
                Name
                Address
                Email
                Phone
                Whatsapp 
                latitude
                longitude
            }
        }
      } `);
  const offices = officeData.glstrapi?.offices;
  const contactBlockContent = {
    "id": "6824756b7848650d288ea1eb",
    "ContactTitle": "Let’s talk",
    "Content": "<p>If you’re looking to buy, sell, let, or simply have questions, our team is here to help. Get in touch with our local experts in Manchester or Hale</p>",
    "Ctas": [
      {
        "Cta_Label": "Book a valuation",
        "Cta_URL": {
          "URL": "book-a-valuation",
          "Secondary_URL": null
        }
      }
    ],
    "Offices": offices
  }
  const handleShow = event => {
    setShow(true)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Share - social icons",
      formType: event + " - " + shareUrl,
      formId: "Share",
      formName: "Share",
      formLabel: "Share",
    })
  }

  const handleClose = () => setShow(false)

  const [show, setShow] = useState(false)
  const { data } = useQuery(GET_ALL_TEAMS)
  const [property_rezise_images, setPropertyReziseImages] = useState("")
  const [negoname, setNegoname] = useState("")
  const [metaTitle, setmetaTitle] = useState('');
  const [metaDesc, setmetaDesc] = useState('');
  useEffect(() => {
    setmetaTitle(props.property_title + ' in ' + props.property_display_address)
    setmetaDesc('Book a viewing for this ' + props.property_title + ' in ' + props.property_display_address + ' with Bentley Hurst at ' + props.property_price + '. Contact Bentley Hurst, and get assisted for all your property needs.')
  }, [])



  useEffect(() => {
    if (
      data &&
      data.teams &&
      data.teams.length > 0 &&
      props.property_negotiator_details?.ID
    ) {
      for (var i = 0; i < data.teams.length; i++) {
        if (props.property_negotiator_details.Email === data.teams[i].Email) {
          setPropertyReziseImages(data.teams[i].Image.url)
          setNegoname(data.teams[i].Name)
        } else if (
          props.property_negotiator_details.Name === data.teams[i].Name
        ) {
          setPropertyReziseImages(data.teams[i].Image.url)
          setNegoname(data.teams[i].Name)
        } else if (
          props.property_negotiator_details.ID === data.teams[i].Repeat_Id
        ) {
          setPropertyReziseImages(data.teams[i].Image.url)
          setNegoname(data.teams[i].Name)
        }
      }
    }
  }, [data])

  const location = useLocation()

  const handleBack = () => {
    //window.history.back();
    console.log(props.property_search_type)
    if (props.property_search_type == "sales") {
      window.location.href = "/property/for-sale/in-manchester"
    }
    if (props.property_search_type == "lettings") {
      window.location.href = "/property/to-rent/in-manchester"
    }
  }

  const handleMakeanOfferLinkClick = () => {
    const authUser = isAuthenticated();

    // My accoount
    if (isBrowser() && !authUser) {
      storeData('auth_return_origin', window.location.href, 'auth');
    }
  }

  const shareUrl = location.href

  const shareurl = typeof window !== "undefined" ? window.location.href : ""

  const [Shareicons, setShareicons] = React.useState(false)
  const openShareicons = () => {
    setShareicons(!Shareicons)
  }

  const closeShareicons = () => {
    setShareicons(false)
  }

  const trackerShare = event => {
    setShareicons(!Shareicons)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Share - social icons",
      formType: event + " - " + shareUrl,
      formId: "Share",
      formName: "Share",
      formLabel: "Share",
    })
  }
  // Share icons

  const detailsRef = useRef(null)
  const detailsScroll = () =>
    detailsRef.current.scrollIntoView({ behavior: "smooth" })

  const mapRef = useRef(null)

  const mapScroll = () => {
    $("html, body").animate(
      {
        scrollTop: $("#mapRef").offset().top - 100,
      },
      1000
    )
  }
  const virtualTour = () => {
    document.querySelector('#virtual_tour').click()
  }

  const videoRef = useRef(null)
  const videoScroll = () =>
    videoRef.current.scrollIntoView({ behavior: "smooth" })
  const [scroll, setScroll] = useState(false)
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 200)
    })
  }, [])
  const bookViewing = (e, addressdisplay) => {
    sessionStorage.setItem('addressdisplay', addressdisplay)
  }

  let propertyImg = null;
  if (props?.property_images && props?.property_images.length > 0) {
    propertyImg = props?.property_images[0]?.hd_url || props?.property_images[0]?.url;
  }
  var buildingType = props?.property_building_type;

  var buildingCapitalize =
    buildingType?.charAt(0).toUpperCase()
    + buildingType?.slice(1)
  var propertyStatus = props.property_status == "For Sale" ? "for Sale" : props.property_status == "To Let" ? "to Rent" : ""
  const viewingBookingUrl = get(props, 'extra.viewing_booking_url', false);

  //console.log("propdetailss-->",props)

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{`{
                        
                        "@context" : "http://schema.org",
                        "@type" : "Product",
                        "name" : "${metaTitle}",
                        "image" : "${propertyImg}",
                        "description" : "${metaDesc}",
                        "brand" : {
                          "@type" : "Organization",
                          "name" : "Bentley Hurst",
                          "logo" : "https://www.bentleyhurst.co.uk/images/mail-logo.png"
                        },
                      "aggregateRating": {
                              "@type": "AggregateRating",
                              "ratingValue": "4.8",
                              "reviewCount": "350"
                          },
                        "offers": {
                              "@type": "Offer",
                        "url": "${location?.href}",
                              "priceCurrency": "GBP",
                              "price": "${props?.property_price}",
                              "availability": "https://schema.org/InStock"
                              }
                                }`}
        </script>

      </Helmet>
      <SEO title={metaTitle} description={metaDesc} />

      <div className="property-content">

        <Modal
          id="share_modal_mobile"
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-90w modal-form"
        >
          <Modal.Header closeButton className="contact-close-btn memberPopup">
            <Modal.Title className="w-100">
              <h6 className="text-center content-primary-color mb-0 text-uppercase">
                Share to a Friend
              </h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SendFriendForm
              property_id={props.property_id}
              page_url={shareUrl}
              property_title={props.property_title ? props.property_title : ""}
              property_img={
                props.property_images && props.property_images.length > 0
                  ? props.property_images[0].hd_url || props.property_images[0].url
                  : ""
              }
              property_address={
                props.property_display_address
                  ? props.property_display_address
                  : ""
              }
              property_bedrooms={
                props.property_bedroom ? props.property_bedroom : ""
              }
              property_bathrooms={
                props.property_bathroom ? props.property_bathroom : ""
              }
            />
          </Modal.Body>
        </Modal>

        <ScrollAnimation
          className={scroll ? "property-header--fixed" : ""}
          animateIn="fadeIn"
          animateOnce={true}
        >
          <div className="property-header d-none d-xl-block">
            <Container
              fluid
              className="d-flex justify-content-between align-items-center"
            >
              {props.property_display_address ? (
                <p className="address-desc">{props.property_display_address}</p>
              ) : (
                ""
              )}
              <div className="navigation">
                <ul className="d-flex">
                  <li>
                    <a href="javascript:void(0)" onClick={detailsScroll}>
                      Details{" "}
                    </a>
                  </li>
                  {(props?.property_video_tour?.length > 0) && (props.property_video_tour[0] !== "") &&
                  <li>
                    <a href="javascript:void(0)" onClick={virtualTour}>
                      Video{" "}
                    </a>
                  </li>}
                  <li>
                    <a href="javascript:void(0)" onClick={mapScroll}>
                      Map
                    </a>
                  </li>
                  {props?.property_brochure?.length > 0 && (
                    <li>
                      <a href={props?.property_brochure[0]?.hd_url || props?.property_brochure[0]?.srcUrl} target="_blank">
                        Brochure
                      </a>
                    </li>
                  )}

                  <li>
                    {props?.property_floorplan?.length > 0 ? (
                      <FloorPlanModal floorplanimg={props.property_floorplan} />
                    ) : (
                      ""
                    )}
                  </li>
                  {!isSold(props.property_status) && (
                    <li>
                      {props.property_department != "dubai_properties" && props.property_department !== "international" && viewingBookingUrl ? <a href={viewingBookingUrl} target="_blank" > Book a viewing</a> :
                        <Link to={props.property_department == "dubai_properties" ? "https://forms.monday.com/forms/3a81a5c387195b2a2552efe68f387b58?r=use1" : "/book-a-viewing"} target={props.property_department == "dubai_properties" ? "_blank" : "_self"} onClick={(e) => bookViewing(e, props.property_display_address)}>{(props.property_department == "international" || props.property_department == "dubai_properties") ? "Enquire now" : "Book a viewing"}</Link>
                      }
                    </li>
                  )}
                  {!isSold(props.property_status) && (props.property_department != "international" && props.property_department != "dubai_properties") && (
                    <li>
                      <Link to="/make-an-offer/" onClick={(e) => handleMakeanOfferLinkClick()}>Make an Offer</Link>
                    </li>
                  )}
                </ul>
              </div>
              <div className="nav-right d-flex align-items-center">


                <a
                  href="javascript:void(0)"
                  className="wishlist-icn property-details-share"
                  onClick={openShareicons}
                >
                  <i className="icon-share"></i>
                </a>
                {Shareicons && (
                  <div className="property-share-social-icons">
                    <FacebookShareButton
                      onClick={() => trackerShare("FacebookShareButton")}
                      url={shareUrl}
                      className="my-share-button facebook-share"
                    >
                      <FacebookIcon size={32} round={false} borderRadius={`10`} />
                    </FacebookShareButton>
                    <TwitterShareButton
                      onClick={() => trackerShare("TwitterShareButton")}
                      url={shareUrl}
                      className="my-share-button twitter-share"
                    >
                      <TwitterIcon size={32} round={false} borderRadius={`10`} />
                    </TwitterShareButton>

                    <EmailShareButton
                      onClick={() => handleShow("SendToFriend")}
                      className="my-share-button email-share"
                    >
                      <EmailIcon size={32} round={false} borderRadius={`10`} />
                    </EmailShareButton>
                    <LinkedinShareButton
                      onClick={() => trackerShare("LinkedinShareButton")}
                      url={shareUrl}
                      className="my-share-button linked-share"
                    >
                      <LinkedinIcon size={32} round={false} borderRadius={`10`} />
                    </LinkedinShareButton>

                    <WhatsappShareButton
                      onClick={() => trackerShare("WhatsappShareButton")}
                      url={shareUrl}
                      className="my-share-button whatsapp-share"
                    >
                      <WhatsappIcon size={32} round={false} borderRadius={`10`} />
                    </WhatsappShareButton>
                  </div>
                )}
                {props.property_department != "international" && props.property_department != "dubai_properties" &&
                  <UserObjectStoreProvider>
                    <SavePropertyWrap property_id={props.property_id} />
                  </UserObjectStoreProvider>
                }
              </div>
            </Container>
          </div>
        </ScrollAnimation>
        {props.property_images && (
          <PropertyDetailsBanner
          
            property_status = {props.property_status}
            property_details_images={props.property_images}
            property_details_image_title={props.property_title}
            property_details_image_id={props.property_image_id}
            property_processedImages={props.processedImages}
            property_floorplan_image={props.property_floorplan}
            property_virtual_tour={props.property_video_tour}
            ggfx_results={props.ggfx_results}
          />
        )}
        <div className="details-wrp" ref={detailsRef}>
          <Container>
            <Row>
              <Col xl={8}>
                {/* <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                <a
                  className="back-listing d-none d-xl-inline-block"
                  href="javascript:void(0)"
                  onClick={handleBack}
                >
                  <i className="back-arrow"></i> Back to Property Listings
                </a>
              </ScrollAnimation> */}
                <BreadcrumbsDetail buildingType={props.property_building_type} searchType={props.property_search_type} propertyArea={props.property_area} />



                <ScrollAnimation
                  animateIn="fadeIn"
                  animateOnce={true}
                  className="detail-heading d-flex d-md-block justify-content-between"
                >
                  {props.property_display_address && props.property_department != "dubai_properties" ? (
                    <h1>{props?.property_bedroom} Bedroom {buildingCapitalize} {propertyStatus} in {props.property_display_address}</h1>
                  ) : props.property_department == "dubai_properties" ? (
                    <h1>{props?.property_title}</h1>
                  ) : ""}
                  {/* <Link className="wishlist-icn" to="#">
                    <i className="icon-heart"></i>
                  </Link> */}
                </ScrollAnimation>
                {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true} delay={700}> */}
                {props.property_price ? (
                  <strong className="price-title d-block">
                    &pound;{props.property_price.toLocaleString()}{" "}{props.property_max_price && props.property_max_price != "0" ? <>- &pound; {props.property_max_price.toLocaleString()}</> : ""}
                    {props.property_search_type === "lettings" ? "pcm" : ""}
                  </strong>
                ) : (
                  ""
                )}
                {props.property_title ? (
                  <span className="feature-txt d-block">
                    {props.property_title}
                  </span>
                ) : (
                  ""
                )}
                {/* </ScrollAnimation> */}
                {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true} delay={900}> */}
                <ul className="feature-list d-md-flex flex-wrap">
                  {props.property_bedroom && props.property_department == "dubai_properties" ? (
                    <li>
                      <span className="feature-icn">
                        <i className="bedroom-icon"></i>
                      </span>{" "}
                      <span>
                        {props.available_bedrooms}
                      </span>
                    </li>
                  ) : props.property_bedroom ? (
                    <li>
                      <span className="feature-icn">
                        <i className="bedroom-icon"></i>
                      </span>{" "}
                      <span className="d-md-none">
                        {props.property_bedroom > 1
                          ? props.property_bedroom + " Beds"
                          : props.property_bedroom + " Bed"}
                      </span>
                      <span className="d-none d-md-inline-block">
                        {props.property_bedroom > 1
                          ? props.property_bedroom + " Bedrooms"
                          : props.property_bedroom + " Bedroom"}
                      </span>
                    </li>
                  ) : ""}
                  {props.property_bathroom ? (
                    <li>
                      <span className="feature-icn">
                        <i className="bathroom-icon"></i>
                      </span>
                      <span className="d-md-none">
                        {props.property_bathroom > 1
                          ? props.property_bathroom + " Baths"
                          : props.property_bathroom + " Bath"}
                      </span>
                      <span className="d-none d-md-inline-block">
                        {props.property_bathroom > 1
                          ? props.property_bathroom + " Bathrooms"
                          : props.property_bathroom + " Bathroom"}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                  {props.property_reception ? (
                    <li>
                      <span className="feature-icn">
                        <i className="reception-icon"></i>
                      </span>
                      <span>{props.property_reception} Reception</span>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
                {/* </ScrollAnimation> */}
                {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true} delay={1000}> */}

                {/* {props.property_description ? (
                
                <p className="desc-txt">{props.property_description}</p>
              ) : (
                ""
              )} */}
                <div className="desc-txt">
                  <ReactMarkdown source={props.property_description} allowDangerousHtml />
                </div>

                <div className="long-desc-txt">
                  <ReactMarkdown source={props.property_long_description} allowDangerousHtml />
                </div>



                {/* {props.property_long_description ? (
                <p className="desc-txt">{props.property_long_description}</p>
              ) : (
                ""
              )} */}

                {/* </ScrollAnimation> */}
              </Col>
              <Col className="d-block" xl={4}>
                <div className="property-quote">
                  {!isNotAvailble(props.property_status) &&
                  <div className="quote-info d-block">
                    <h4 className="quote-title">Interested in this property?</h4>
                    <div className="quote-btns">
                      {!isSold(props.property_status) && (
                        props.property_department !== "international" && props.property_department !== "dubai_properties" && viewingBookingUrl
                          ? <a href={viewingBookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Book a viewing</a>
                          : <Link to={props.property_department === "dubai_properties" ? "https://forms.monday.com/forms/3a81a5c387195b2a2552efe68f387b58?r=use1" : "/book-a-viewing/"} target={props.property_department === "dubai_properties" ? "_blank" : "_self"} className="btn btn-primary">{["international", "dubai_properties"].includes(props.property_department) ? "Enquire now" : "Book a viewing"}</Link>
                      )}
                      {!isSold(props.property_status) && (props.property_department != "international" && props.property_department != "dubai_properties") && (
                        <Link to="/make-an-offer/" className="btn btn-primary" onClick={(e) => handleMakeanOfferLinkClick()}>
                          Make an Offer
                        </Link>
                      )}
                      {props.property_department != "dubai_properties" &&
                        <Link
                          to={VALUATION_PAGE_UEL.alias + '/'}
                          className="btn btn-outline bold"
                        >
                          Book a property valuation
                        </Link>
                      }
                    </div>
                  </div>
                  }
                  {props.property_negotiator_details && props.property_negotiator_details?.Telephone ? (
                    <div className="negotiator d-flex  mobile-view">
                      <div className="negotiator-data">
                        <figure>
                          {property_rezise_images ? (
                            <img src={property_rezise_images} alt="profile" />
                          ) : (
                            ""
                          )}
                        </figure>
                        <div className="info">
                          {negoname ? (
                            <strong className="name">{negoname}</strong>
                          ) : (
                            ""
                          )}
                          <p className="post">Property Negotiator</p>
                          {props.property_negotiator_details.Telephone ? (
                            <a
                              className="contact-no"
                              href={
                                "tel:" +
                                uknumberformatFront1(
                                  props.property_negotiator_details.Telephone.replace(
                                    /\D/g,
                                    ""
                                  )
                                )
                              }
                            >
                              {uknumberformatFront1(
                                props.property_negotiator_details.Telephone
                              )}
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {isMobileOnly && (
                        <ul className="plan-list">
                          <li>
                            {props?.property_video_tour?.length > 0 ? (
                              <VirtualTourModalDetails
                                videourl={props.property_video_tour[0]?.hd_url || props.property_video_tour[0]}
                                icon={""}
                              />
                            ) : (
                              ""
                            )}
                          </li>
                          <li>
                            {props?.property_floorplan?.length > 0 ? (
                              <FloorPlanModal
                                floorplanimg={props.property_floorplan}
                              />
                            ) : (
                              ""
                            )}
                          </li>
                          {/* <li>
                            <Link to="#">Brochure</Link>
                          </li> */}
                          <li>
                            <a
                              href="javascript:void(0)"
                              className="wishlist-icn property-details-share"
                              onClick={openShareicons}
                            >
                              Share With Friends
                            </a>
                            {Shareicons && (
                              <div className="property-share-social-icon mobile-icons">
                                <FacebookShareButton
                                  onClick={() =>
                                    trackerShare("FacebookShareButton")
                                  }
                                  url={shareUrl}
                                  className="my-share-button facebook-share"
                                >
                                  <FacebookIcon
                                    size={32}
                                    round={false}
                                    borderRadius={`10`}
                                  />
                                </FacebookShareButton>
                                <TwitterShareButton
                                  onClick={() =>
                                    trackerShare("TwitterShareButton")
                                  }
                                  url={shareUrl}
                                  className="my-share-button twitter-share"
                                >
                                  <TwitterIcon
                                    size={32}
                                    round={false}
                                    borderRadius={`10`}
                                  />
                                </TwitterShareButton>

                                <EmailShareButton
                                  onClick={() => handleShow("SendToFriend")}
                                  className="my-share-button email-share"
                                >
                                  <EmailIcon
                                    size={32}
                                    round={false}
                                    borderRadius={`10`}
                                  />
                                </EmailShareButton>
                                <LinkedinShareButton
                                  onClick={() =>
                                    trackerShare("LinkedinShareButton")
                                  }
                                  url={shareUrl}
                                  className="my-share-button linked-share"
                                >
                                  <LinkedinIcon
                                    size={32}
                                    round={false}
                                    borderRadius={`10`}
                                  />
                                </LinkedinShareButton>

                                <WhatsappShareButton
                                  onClick={() =>
                                    trackerShare("WhatsappShareButton")
                                  }
                                  url={shareUrl}
                                  className="my-share-button whatsapp-share"
                                >
                                  <WhatsappIcon
                                    size={32}
                                    round={false}
                                    borderRadius={`10`}
                                  />
                                </WhatsappShareButton>
                              </div>
                            )}
                          </li>
                        </ul>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {props.property_latitude && props.property_department == "residential" && (
          <div id="mapRef">
            <PropertyMap
              property_map_lat={props.property_latitude}
              property_map_lng={props.property_longitude}
            />
          </div>
        )}
        {props.property_latitude && (props.property_department == "international") && (
          <div id="mapRef" className="property-map">
            <GoogleMap location={{ lat: props.property_latitude, lng: props.property_longitude }}
              property_map_lat={props.property_latitude}
              property_map_lng={props.property_longitude}
            />
          </div>
        )}
        {/* {props.postcode && props.postcode != undefined && (
        <div ref={videoRef}>
          <PropertyAbout postcode={props.postcode?.split(" ")[0]} />
        </div>
      )} */}
        {props.property_id && <SimilarPropery pid={props.property_id} />}
        <ContactBlock {...contactBlockContent} />
        {/* <StaticContactBlock /> */}
      </div></>
  )
}

export default PropertyDetails
